// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1JzCC","title":"ClientInsurance_title__eMULW","itemText":"ClientInsurance_itemText__3-Bnx"};